import { Alert as AntdAlert } from 'antd'

export const Alert = AntdAlert
